import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class generalTaskFormCtrl implements IController {

  generalTask: any;

  private generalTaskMap: any;
  private startServiceTimeInMinutes: any;
  private endServiceTimeInMinutes: any;
  private types: any;
  private selectedTemplateId: any;
  private selectedTemplate: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.generalTaskMap = {};
    this.startServiceTimeInMinutes = null;
    this.endServiceTimeInMinutes = null;
    this.types = ['General'];
    this.selectedTemplateId = undefined;

    if (_.get(this.generalTask, 'detailedServiceTime.entryTime')) {
      this.startServiceTimeInMinutes = this.generalTask.detailedServiceTime.entryTime / 60000;
    }
    if (_.get(this.generalTask, 'detailedServiceTime.exitTime')) {
      this.endServiceTimeInMinutes = this.generalTask.detailedServiceTime.exitTime / 60000;
    }
  }

  $onChanges(changes) {
    if (changes.generalTask && !changes.generalTask.isFirstChange()) {
      // if (!ctrl.generalTask) {
      //     ctrl.generalTask = {};
      // }
    }
  }

  // ******************************
  //        Public methods
  // ******************************

  onTemplateSelect(template) {
    this.selectedTemplate = template;
  }

  onAdd() {
    if (this.selectedTemplate) {

      if (!this.generalTask.subTaskTemplates) {
        this.generalTask.subTaskTemplates = [];
      }

      if (!this.generalTask.subTaskTemplateIds) {
        this.generalTask.subTaskTemplateIds = [];
      }

      const templateExists = _.some(this.generalTask.subTaskTemplates, (t) => {
        return _.isEqual(this.selectedTemplate.templateId, t.templateId);
      });

      if (!templateExists) {
        this.generalTask.subTaskTemplates.push(this.selectedTemplate);
        this.generalTask.subTaskTemplateIds.push(this.selectedTemplate.templateId);
      }
    }
  }

  onStartServiceTimeChange(serviceTimeInMinutes) {
    if (!this.generalTask.detailedServiceTime) {
      this.generalTask.detailedServiceTime = {};
    }
    this.generalTask.detailedServiceTime.entryTime = serviceTimeInMinutes ?
      (serviceTimeInMinutes * 60000) : undefined;
  }

  onEndServiceTimeChange(serviceTimeInMinutes) {
    if (!this.generalTask.detailedServiceTime) {
      this.generalTask.detailedServiceTime = {};
    }
    this.generalTask.detailedServiceTime.exitTime = serviceTimeInMinutes ?
      (serviceTimeInMinutes * 60000) : undefined;
  }

  onRemoveSubTask(subTaskId) {
    this.generalTask.subTaskTemplates = _.filter(this.generalTask.subTaskTemplates, (subTask) => {
      return subTask.templateId !== subTaskId;
    })
    this.generalTask.subTaskTemplateIds = _.filter(this.generalTask.subTaskTemplateIds, (id) => {
      return id !== subTaskId;
    })
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .component('generalTaskForm', {
    bindings: {
      generalTask: '<'
    },
    template: require('./general-task-form.html').default,
    controller: generalTaskFormCtrl
  });
